import Browser from '../../src/helpers/browser';
import isTestEnvironment from './is-testenv';
import StaticIdSingletonClass from './static-id';

/**
 * Enable console log based on the debug flag.
 * @param {string} message
 * @param {data} data
 */
/* eslint-disable */
const LOGGER_STYLE = 'font-weight: bold';
const logger = (message, data = '') => {
  if ((StaticIdSingletonClass.debug && isTestEnvironment()) || window.VISA_SDK_DEBUG) {
    Browser.checkIE11OrEdgeBrowser()
      ? console.log(`Visa ORCH SDK -- ${message}`, data)
      : console.log(`%cVisa ORCH SDK -- ${message}`, LOGGER_STYLE, data);
  }
};

export default logger;
